"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/ordermade/v1/ems_service.proto (package spwn.ordermade.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse = exports.EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest = exports.EMSOrdermadeServiceGetCanCreateShopResponse = exports.EMSOrdermadeServiceGetCanCreateShopRequest = exports.EMSOrdermadeServiceGetPermissionLevelResponse = exports.EMSOrdermadeServiceGetPermissionLevelRequest = exports.EMSOrdermadeServiceSearchTalentProfilesResponse = exports.EMSOrdermadeServiceSearchTalentProfilesRequest = exports.EMSOrdermadeServiceRejectBrandApplicationResponse = exports.EMSOrdermadeServiceRejectBrandApplicationRequest = exports.EMSOrdermadeServiceApproveBrandApplicationResponse = exports.EMSOrdermadeServiceApproveBrandApplicationRequest = exports.EMSOrdermadeServiceGetBrandApplicationByIdResponse = exports.EMSOrdermadeServiceGetBrandApplicationByIdRequest = exports.EMSOrdermadeServiceGetBrandApplicationsResponse = exports.EMSOrdermadeServiceGetBrandApplicationsRequest = exports.EMSOrdermadeServiceBrandApplicationDetail = exports.EMSOrdermadeServiceBrandApplicationSummary = exports.EMSOrdermadeServiceTalentProfile = exports.EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse = exports.EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest = exports.EMSOrdermadeServiceSubmitBrandApplicationResponse = exports.EMSOrdermadeServiceSubmitBrandApplicationRequest = exports.EMSOrdermadeServiceSubmitBrandApplicationError = exports.EMSOrdermadeFactoryBaseItemSizeOptionValue = exports.EMSOrdermadeFactoryBaseItemColorOptionValue = exports.EMSOrdermadeFactoryBaseItem = exports.EMSOrdermadeServiceGetFactoryBaseItemsResponse = exports.EMSOrdermadeServiceGetFactoryBaseItemsRequest = exports.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse = exports.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest = exports.EMSOrdermadeServiceEditOrdermadeProductDesignResponse = exports.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign = exports.EMSOrdermadeServiceEditOrdermadeProductDesignRequest = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest = exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse = exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign = exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig = exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest = exports.EMSOrdermadeServiceGetOrdermadeProductByIdResponse = exports.EMSOrdermadeServiceGetOrdermadeProductByIdRequest = exports.EMSOrdermadeServiceGetOrdermadeProductsResponse = exports.EMSOrdermadeServiceGetOrdermadeProductsRequest = exports.EMSOrdermadeServiceBrandApplicationErrorReason = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const ems_common_pb_1 = require("./ems_common_pb");
/**
 * SubmitBrandApplicationのエラー詳細（ConnectErrorのdetailsで返す）
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationErrorReason
 */
var EMSOrdermadeServiceBrandApplicationErrorReason;
(function (EMSOrdermadeServiceBrandApplicationErrorReason) {
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED = 0;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED";
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_ALREADY_EXISTS = 1;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_ALREADY_EXISTS"] = 1] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_ALREADY_EXISTS";
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_PROHIBITED = 2;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_PROHIBITED"] = 2] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_PROHIBITED";
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_INVALID_FORMAT = 3;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_INVALID_FORMAT"] = 3] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_INVALID_FORMAT";
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_PENDING_LIMIT_EXCEEDED = 4;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_PENDING_LIMIT_EXCEEDED"] = 4] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_PENDING_LIMIT_EXCEEDED";
})(EMSOrdermadeServiceBrandApplicationErrorReason = exports.EMSOrdermadeServiceBrandApplicationErrorReason || (exports.EMSOrdermadeServiceBrandApplicationErrorReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeServiceBrandApplicationErrorReason)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeServiceBrandApplicationErrorReason, "spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationErrorReason", [
    { no: 0, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_ALREADY_EXISTS" },
    { no: 2, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_PROHIBITED" },
    { no: 3, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_INVALID_FORMAT" },
    { no: 4, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_PENDING_LIMIT_EXCEEDED" },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductsRequest
 */
class EMSOrdermadeServiceGetOrdermadeProductsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * フィルタリング用のタグIDリスト
         *
         * @generated from field: repeated string tag_ids = 1;
         */
        this.tagIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductsRequest = EMSOrdermadeServiceGetOrdermadeProductsRequest;
EMSOrdermadeServiceGetOrdermadeProductsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductsRequest";
EMSOrdermadeServiceGetOrdermadeProductsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "publish_status", kind: "enum", T: protobuf_1.proto3.getEnumType(ems_common_pb_1.EMSOrdermadeProductPublishStatus), opt: true },
    { no: 3, name: "listing_review_status", kind: "enum", T: protobuf_1.proto3.getEnumType(ems_common_pb_1.EMSOrdermadeProductListingReviewStatus), opt: true },
    { no: 4, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductsResponse
 */
class EMSOrdermadeServiceGetOrdermadeProductsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductListItem products = 1;
         */
        this.products = [];
        /**
         * @generated from field: int32 total_pages = 2;
         */
        this.totalPages = 0;
        /**
         * @generated from field: int32 current_page = 3;
         */
        this.currentPage = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductsResponse = EMSOrdermadeServiceGetOrdermadeProductsResponse;
EMSOrdermadeServiceGetOrdermadeProductsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductsResponse";
EMSOrdermadeServiceGetOrdermadeProductsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "products", kind: "message", T: ems_common_pb_1.EMSOrdermadeProductListItem, repeated: true },
    { no: 2, name: "total_pages", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "current_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductByIdRequest
 */
class EMSOrdermadeServiceGetOrdermadeProductByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductByIdRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductByIdRequest = EMSOrdermadeServiceGetOrdermadeProductByIdRequest;
EMSOrdermadeServiceGetOrdermadeProductByIdRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductByIdRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductByIdRequest";
EMSOrdermadeServiceGetOrdermadeProductByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductByIdResponse
 */
class EMSOrdermadeServiceGetOrdermadeProductByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductByIdResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductByIdResponse = EMSOrdermadeServiceGetOrdermadeProductByIdResponse;
EMSOrdermadeServiceGetOrdermadeProductByIdResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductByIdResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductByIdResponse";
EMSOrdermadeServiceGetOrdermadeProductByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "product", kind: "message", T: ems_common_pb_1.EMSOrdermadeProduct },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest
 */
class EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * メイン画像ID
         *
         * @generated from field: string om_brand_image_id = 1;
         */
        this.omBrandImageId = "";
        /**
         * 商品マスタごとの設定
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig base_item_configs = 2;
         */
        this.baseItemConfigs = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest = EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest;
EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest";
EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_brand_image_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "base_item_configs", kind: "message", T: EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig
 */
class EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 工場商品マスタID
         *
         * @generated from field: string factory_base_item_id = 1;
         */
        this.factoryBaseItemId = "";
        /**
         * 販売するカラーの工場オプション値IDリスト
         *
         * @generated from field: repeated string factory_color_option_value_ids = 2;
         */
        this.factoryColorOptionValueIds = [];
        /**
         * 販売するサイズの工場オプション値IDリスト
         *
         * @generated from field: repeated string factory_size_option_value_ids = 3;
         */
        this.factorySizeOptionValueIds = [];
        /**
         * デザイン編集画面で設定した面ごとのデザイン (未編集の面は省略可)
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign surface_designs = 4;
         */
        this.surfaceDesigns = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig, a, b);
    }
}
exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig = EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig;
EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig.runtime = protobuf_1.proto3;
EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig";
EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "factory_base_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "factory_color_option_value_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "factory_size_option_value_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "surface_designs", kind: "message", T: EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign
 */
class EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 印刷面ID(om_factory_print_surface.surface_codeの値)
         *
         * @generated from field: string surface_code = 1;
         */
        this.surfaceCode = "";
        /**
         * konvaが生成したデザインスペック(JSON string)
         *
         * @generated from field: string konva_design_spec = 2;
         */
        this.konvaDesignSpec = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign, a, b);
    }
}
exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign = EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign;
EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign.runtime = protobuf_1.proto3;
EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign";
EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "surface_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "konva_design_spec", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse
 */
class EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 作成された商品IDリスト
         *
         * @generated from field: repeated string om_product_ids = 1;
         */
        this.omProductIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse = EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse;
EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse";
EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest
 */
class EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新対象の商品ID
         *
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        /**
         * バリアントの更新
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant variants = 4;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest, a, b);
    }
}
exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest = EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest;
EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest";
EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description_as_tiptap", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "variants", kind: "message", T: EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant
 */
class EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリアントID
         *
         * @generated from field: string om_product_variant_id = 1;
         */
        this.omProductVariantId = "";
        /**
         * 販売するかどうか（falseにすると在庫0として売り切れ表示になる）
         *
         * @generated from field: bool is_on_sale = 3;
         */
        this.isOnSale = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant, a, b);
    }
}
exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant = EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant;
EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant";
EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "is_on_sale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse
 */
class EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新した商品ID
         *
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse, a, b);
    }
}
exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse = EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse;
EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse";
EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * OM商品デザイン編集リクエスト
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignRequest
 */
class EMSOrdermadeServiceEditOrdermadeProductDesignRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新対象の商品ID
         *
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        /**
         * 販売するカラーの工場オプション値IDリスト
         *
         * @generated from field: repeated string factory_color_option_value_ids = 2;
         */
        this.factoryColorOptionValueIds = [];
        /**
         * 販売するサイズの工場オプション値IDリスト
         *
         * @generated from field: repeated string factory_size_option_value_ids = 3;
         */
        this.factorySizeOptionValueIds = [];
        /**
         * 商品に設定する全ての面のデザイン（送信された面が現状の全てとして扱われ、省略された面は削除される）
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign surface_designs = 4;
         */
        this.surfaceDesigns = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceEditOrdermadeProductDesignRequest, a, b);
    }
}
exports.EMSOrdermadeServiceEditOrdermadeProductDesignRequest = EMSOrdermadeServiceEditOrdermadeProductDesignRequest;
EMSOrdermadeServiceEditOrdermadeProductDesignRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceEditOrdermadeProductDesignRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignRequest";
EMSOrdermadeServiceEditOrdermadeProductDesignRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "factory_color_option_value_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "factory_size_option_value_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "surface_designs", kind: "message", T: EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign, repeated: true },
]);
/**
 * 面ごとのデザイン
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign
 */
class EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 印刷面ID(om_factory_print_surface.surface_codeの値)
         *
         * @generated from field: string surface_code = 1;
         */
        this.surfaceCode = "";
        /**
         * konvaが生成したデザインスペック(JSON string)
         *
         * @generated from field: string konva_design_spec = 2;
         */
        this.konvaDesignSpec = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign, a, b);
    }
}
exports.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign = EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign;
EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign.runtime = protobuf_1.proto3;
EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign";
EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "surface_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "konva_design_spec", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * OM商品デザイン編集レスポンス
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignResponse
 */
class EMSOrdermadeServiceEditOrdermadeProductDesignResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新した商品ID
         *
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceEditOrdermadeProductDesignResponse, a, b);
    }
}
exports.EMSOrdermadeServiceEditOrdermadeProductDesignResponse = EMSOrdermadeServiceEditOrdermadeProductDesignResponse;
EMSOrdermadeServiceEditOrdermadeProductDesignResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceEditOrdermadeProductDesignResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignResponse";
EMSOrdermadeServiceEditOrdermadeProductDesignResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest
 */
class EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アップロード予定ファイル拡張子
         *
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeImageFileExtension file_extension = 1;
         */
        this.fileExtension = ems_common_pb_1.EMSOrdermadeImageFileExtension.EMS_ORDERMADE_IMAGE_FILE_EXTENSION_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest = EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest;
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest";
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "file_extension", kind: "enum", T: protobuf_1.proto3.getEnumType(ems_common_pb_1.EMSOrdermadeImageFileExtension) },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse
 */
class EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 作成されたブランド画像ID
         *
         * @generated from field: string om_brand_image_id = 1;
         */
        this.omBrandImageId = "";
        /**
         * アップロード時に指定するヘッダー 基本的にcontent-typeくらいしか返さない想定
         *
         * @generated from field: map<string, string> headers_for_upload = 2;
         */
        this.headersForUpload = {};
        /**
         * アップロード用Signed URL
         *
         * @generated from field: string url_for_upload = 3;
         */
        this.urlForUpload = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse = EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse;
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse";
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_brand_image_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "headers_for_upload", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 3, name: "url_for_upload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetFactoryBaseItemsRequest
 */
class EMSOrdermadeServiceGetFactoryBaseItemsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 指定した工場商品マスタのみ取得 (未指定の場合は全件)
         *
         * @generated from field: repeated string ids = 1;
         */
        this.ids = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetFactoryBaseItemsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetFactoryBaseItemsRequest = EMSOrdermadeServiceGetFactoryBaseItemsRequest;
EMSOrdermadeServiceGetFactoryBaseItemsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetFactoryBaseItemsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetFactoryBaseItemsRequest";
EMSOrdermadeServiceGetFactoryBaseItemsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetFactoryBaseItemsResponse
 */
class EMSOrdermadeServiceGetFactoryBaseItemsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItem factory_base_items = 1;
         */
        this.factoryBaseItems = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetFactoryBaseItemsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetFactoryBaseItemsResponse = EMSOrdermadeServiceGetFactoryBaseItemsResponse;
EMSOrdermadeServiceGetFactoryBaseItemsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetFactoryBaseItemsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetFactoryBaseItemsResponse";
EMSOrdermadeServiceGetFactoryBaseItemsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "factory_base_items", kind: "message", T: EMSOrdermadeFactoryBaseItem, repeated: true },
]);
/**
 * 工場商品マスタ
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItem
 */
class EMSOrdermadeFactoryBaseItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * 商品名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * カラーオプション値一覧
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemColorOptionValue colors = 4;
         */
        this.colors = [];
        /**
         * サイズオプション値一覧
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemSizeOptionValue sizes = 5;
         */
        this.sizes = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItem, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItem = EMSOrdermadeFactoryBaseItem;
EMSOrdermadeFactoryBaseItem.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItem.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItem";
EMSOrdermadeFactoryBaseItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "preview_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "colors", kind: "message", T: EMSOrdermadeFactoryBaseItemColorOptionValue, repeated: true },
    { no: 5, name: "sizes", kind: "message", T: EMSOrdermadeFactoryBaseItemSizeOptionValue, repeated: true },
]);
/**
 * カラーオプション値
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemColorOptionValue
 */
class EMSOrdermadeFactoryBaseItemColorOptionValue extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 原価(円)
         *
         * @generated from field: int32 cost = 3;
         */
        this.cost = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemColorOptionValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemColorOptionValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemColorOptionValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemColorOptionValue, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemColorOptionValue = EMSOrdermadeFactoryBaseItemColorOptionValue;
EMSOrdermadeFactoryBaseItemColorOptionValue.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemColorOptionValue.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemColorOptionValue";
EMSOrdermadeFactoryBaseItemColorOptionValue.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * サイズオプション値
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemSizeOptionValue
 */
class EMSOrdermadeFactoryBaseItemSizeOptionValue extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemSizeOptionValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemSizeOptionValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemSizeOptionValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemSizeOptionValue, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemSizeOptionValue = EMSOrdermadeFactoryBaseItemSizeOptionValue;
EMSOrdermadeFactoryBaseItemSizeOptionValue.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemSizeOptionValue.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemSizeOptionValue";
EMSOrdermadeFactoryBaseItemSizeOptionValue.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationError
 */
class EMSOrdermadeServiceSubmitBrandApplicationError extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationErrorReason reason = 1;
         */
        this.reason = EMSOrdermadeServiceBrandApplicationErrorReason.EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSubmitBrandApplicationError, a, b);
    }
}
exports.EMSOrdermadeServiceSubmitBrandApplicationError = EMSOrdermadeServiceSubmitBrandApplicationError;
EMSOrdermadeServiceSubmitBrandApplicationError.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSubmitBrandApplicationError.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationError";
EMSOrdermadeServiceSubmitBrandApplicationError.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeServiceBrandApplicationErrorReason) },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationRequest
 */
class EMSOrdermadeServiceSubmitBrandApplicationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string shop_name = 1;
         */
        this.shopName = "";
        /**
         * @generated from field: string slug = 2;
         */
        this.slug = "";
        /**
         * @generated from field: repeated string talent_ids = 3;
         */
        this.talentIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSubmitBrandApplicationRequest, a, b);
    }
}
exports.EMSOrdermadeServiceSubmitBrandApplicationRequest = EMSOrdermadeServiceSubmitBrandApplicationRequest;
EMSOrdermadeServiceSubmitBrandApplicationRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSubmitBrandApplicationRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationRequest";
EMSOrdermadeServiceSubmitBrandApplicationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "talent_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationResponse
 */
class EMSOrdermadeServiceSubmitBrandApplicationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSubmitBrandApplicationResponse, a, b);
    }
}
exports.EMSOrdermadeServiceSubmitBrandApplicationResponse = EMSOrdermadeServiceSubmitBrandApplicationResponse;
EMSOrdermadeServiceSubmitBrandApplicationResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSubmitBrandApplicationResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationResponse";
EMSOrdermadeServiceSubmitBrandApplicationResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest
 */
class EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest = EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest;
EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest";
EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse
 */
class EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string shop_names = 1;
         */
        this.shopNames = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse = EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse;
EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse";
EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shop_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * タレントプロフィール（SearchTalentProfilesでも再利用）
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceTalentProfile
 */
class EMSOrdermadeServiceTalentProfile extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string talent_id = 1;
         */
        this.talentId = "";
        /**
         * @generated from field: string talent_name = 2;
         */
        this.talentName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceTalentProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceTalentProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceTalentProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceTalentProfile, a, b);
    }
}
exports.EMSOrdermadeServiceTalentProfile = EMSOrdermadeServiceTalentProfile;
EMSOrdermadeServiceTalentProfile.runtime = protobuf_1.proto3;
EMSOrdermadeServiceTalentProfile.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceTalentProfile";
EMSOrdermadeServiceTalentProfile.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "talent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "talent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 販売元追加申請一覧用
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationSummary
 */
class EMSOrdermadeServiceBrandApplicationSummary extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        /**
         * @generated from field: string shop_name = 2;
         */
        this.shopName = "";
        /**
         * @generated from field: string slug = 3;
         */
        this.slug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceBrandApplicationSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceBrandApplicationSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceBrandApplicationSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceBrandApplicationSummary, a, b);
    }
}
exports.EMSOrdermadeServiceBrandApplicationSummary = EMSOrdermadeServiceBrandApplicationSummary;
EMSOrdermadeServiceBrandApplicationSummary.runtime = protobuf_1.proto3;
EMSOrdermadeServiceBrandApplicationSummary.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationSummary";
EMSOrdermadeServiceBrandApplicationSummary.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "submitted_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * 販売元追加申請詳細（承認/却下判断に必要な情報）
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationDetail
 */
class EMSOrdermadeServiceBrandApplicationDetail extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        /**
         * @generated from field: string shop_name = 2;
         */
        this.shopName = "";
        /**
         * @generated from field: string slug = 3;
         */
        this.slug = "";
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceTalentProfile talents = 4;
         */
        this.talents = [];
        /**
         * @generated from field: string applicant_email = 5;
         */
        this.applicantEmail = "";
        /**
         * @generated from field: string applicant_name = 6;
         */
        this.applicantName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceBrandApplicationDetail().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceBrandApplicationDetail().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceBrandApplicationDetail().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceBrandApplicationDetail, a, b);
    }
}
exports.EMSOrdermadeServiceBrandApplicationDetail = EMSOrdermadeServiceBrandApplicationDetail;
EMSOrdermadeServiceBrandApplicationDetail.runtime = protobuf_1.proto3;
EMSOrdermadeServiceBrandApplicationDetail.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationDetail";
EMSOrdermadeServiceBrandApplicationDetail.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "talents", kind: "message", T: EMSOrdermadeServiceTalentProfile, repeated: true },
    { no: 5, name: "applicant_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "applicant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * pending状態の申請のみ返却、ページネーション不要
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationsRequest
 */
class EMSOrdermadeServiceGetBrandApplicationsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetBrandApplicationsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetBrandApplicationsRequest = EMSOrdermadeServiceGetBrandApplicationsRequest;
EMSOrdermadeServiceGetBrandApplicationsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetBrandApplicationsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationsRequest";
EMSOrdermadeServiceGetBrandApplicationsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationsResponse
 */
class EMSOrdermadeServiceGetBrandApplicationsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationSummary applications = 1;
         */
        this.applications = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetBrandApplicationsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetBrandApplicationsResponse = EMSOrdermadeServiceGetBrandApplicationsResponse;
EMSOrdermadeServiceGetBrandApplicationsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetBrandApplicationsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationsResponse";
EMSOrdermadeServiceGetBrandApplicationsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "applications", kind: "message", T: EMSOrdermadeServiceBrandApplicationSummary, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationByIdRequest
 */
class EMSOrdermadeServiceGetBrandApplicationByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetBrandApplicationByIdRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetBrandApplicationByIdRequest = EMSOrdermadeServiceGetBrandApplicationByIdRequest;
EMSOrdermadeServiceGetBrandApplicationByIdRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetBrandApplicationByIdRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationByIdRequest";
EMSOrdermadeServiceGetBrandApplicationByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationByIdResponse
 */
class EMSOrdermadeServiceGetBrandApplicationByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetBrandApplicationByIdResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetBrandApplicationByIdResponse = EMSOrdermadeServiceGetBrandApplicationByIdResponse;
EMSOrdermadeServiceGetBrandApplicationByIdResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetBrandApplicationByIdResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationByIdResponse";
EMSOrdermadeServiceGetBrandApplicationByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application", kind: "message", T: EMSOrdermadeServiceBrandApplicationDetail },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceApproveBrandApplicationRequest
 */
class EMSOrdermadeServiceApproveBrandApplicationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceApproveBrandApplicationRequest, a, b);
    }
}
exports.EMSOrdermadeServiceApproveBrandApplicationRequest = EMSOrdermadeServiceApproveBrandApplicationRequest;
EMSOrdermadeServiceApproveBrandApplicationRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceApproveBrandApplicationRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceApproveBrandApplicationRequest";
EMSOrdermadeServiceApproveBrandApplicationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceApproveBrandApplicationResponse
 */
class EMSOrdermadeServiceApproveBrandApplicationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceApproveBrandApplicationResponse, a, b);
    }
}
exports.EMSOrdermadeServiceApproveBrandApplicationResponse = EMSOrdermadeServiceApproveBrandApplicationResponse;
EMSOrdermadeServiceApproveBrandApplicationResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceApproveBrandApplicationResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceApproveBrandApplicationResponse";
EMSOrdermadeServiceApproveBrandApplicationResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceRejectBrandApplicationRequest
 */
class EMSOrdermadeServiceRejectBrandApplicationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceRejectBrandApplicationRequest, a, b);
    }
}
exports.EMSOrdermadeServiceRejectBrandApplicationRequest = EMSOrdermadeServiceRejectBrandApplicationRequest;
EMSOrdermadeServiceRejectBrandApplicationRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceRejectBrandApplicationRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceRejectBrandApplicationRequest";
EMSOrdermadeServiceRejectBrandApplicationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceRejectBrandApplicationResponse
 */
class EMSOrdermadeServiceRejectBrandApplicationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceRejectBrandApplicationResponse, a, b);
    }
}
exports.EMSOrdermadeServiceRejectBrandApplicationResponse = EMSOrdermadeServiceRejectBrandApplicationResponse;
EMSOrdermadeServiceRejectBrandApplicationResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceRejectBrandApplicationResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceRejectBrandApplicationResponse";
EMSOrdermadeServiceRejectBrandApplicationResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSearchTalentProfilesRequest
 */
class EMSOrdermadeServiceSearchTalentProfilesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string keyword = 1;
         */
        this.keyword = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSearchTalentProfilesRequest, a, b);
    }
}
exports.EMSOrdermadeServiceSearchTalentProfilesRequest = EMSOrdermadeServiceSearchTalentProfilesRequest;
EMSOrdermadeServiceSearchTalentProfilesRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSearchTalentProfilesRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSearchTalentProfilesRequest";
EMSOrdermadeServiceSearchTalentProfilesRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSearchTalentProfilesResponse
 */
class EMSOrdermadeServiceSearchTalentProfilesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceTalentProfile talents = 1;
         */
        this.talents = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSearchTalentProfilesResponse, a, b);
    }
}
exports.EMSOrdermadeServiceSearchTalentProfilesResponse = EMSOrdermadeServiceSearchTalentProfilesResponse;
EMSOrdermadeServiceSearchTalentProfilesResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSearchTalentProfilesResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSearchTalentProfilesResponse";
EMSOrdermadeServiceSearchTalentProfilesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "talents", kind: "message", T: EMSOrdermadeServiceTalentProfile, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetPermissionLevelRequest
 */
class EMSOrdermadeServiceGetPermissionLevelRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetPermissionLevelRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetPermissionLevelRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetPermissionLevelRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetPermissionLevelRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetPermissionLevelRequest = EMSOrdermadeServiceGetPermissionLevelRequest;
EMSOrdermadeServiceGetPermissionLevelRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetPermissionLevelRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetPermissionLevelRequest";
EMSOrdermadeServiceGetPermissionLevelRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetPermissionLevelResponse
 */
class EMSOrdermadeServiceGetPermissionLevelResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool can_review_shop_application = 1;
         */
        this.canReviewShopApplication = false;
        /**
         * @generated from field: bool can_manage_user_invitations = 2;
         */
        this.canManageUserInvitations = false;
        /**
         * @generated from field: bool can_change_user_roles = 3;
         */
        this.canChangeUserRoles = false;
        /**
         * @generated from field: bool can_delete_users = 4;
         */
        this.canDeleteUsers = false;
        /**
         * @generated from field: bool can_approve_product_for_sale = 5;
         */
        this.canApproveProductForSale = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetPermissionLevelResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetPermissionLevelResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetPermissionLevelResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetPermissionLevelResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetPermissionLevelResponse = EMSOrdermadeServiceGetPermissionLevelResponse;
EMSOrdermadeServiceGetPermissionLevelResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetPermissionLevelResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetPermissionLevelResponse";
EMSOrdermadeServiceGetPermissionLevelResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "can_review_shop_application", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_manage_user_invitations", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "can_change_user_roles", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "can_delete_users", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "can_approve_product_for_sale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetCanCreateShopRequest
 */
class EMSOrdermadeServiceGetCanCreateShopRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetCanCreateShopRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetCanCreateShopRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetCanCreateShopRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetCanCreateShopRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetCanCreateShopRequest = EMSOrdermadeServiceGetCanCreateShopRequest;
EMSOrdermadeServiceGetCanCreateShopRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetCanCreateShopRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetCanCreateShopRequest";
EMSOrdermadeServiceGetCanCreateShopRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetCanCreateShopResponse
 */
class EMSOrdermadeServiceGetCanCreateShopResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool can_create_shop = 1;
         */
        this.canCreateShop = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetCanCreateShopResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetCanCreateShopResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetCanCreateShopResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetCanCreateShopResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetCanCreateShopResponse = EMSOrdermadeServiceGetCanCreateShopResponse;
EMSOrdermadeServiceGetCanCreateShopResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetCanCreateShopResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetCanCreateShopResponse";
EMSOrdermadeServiceGetCanCreateShopResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "can_create_shop", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * 申請日時の降順（新しい順）で返す
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest
 */
class EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest = EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest;
EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest";
EMSOrdermadeServiceGetPendingBrandApplicationsForTenantRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 2, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse
 */
class EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationSummary applications = 1;
         */
        this.applications = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse = EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse;
EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse";
EMSOrdermadeServiceGetPendingBrandApplicationsForTenantResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "applications", kind: "message", T: EMSOrdermadeServiceBrandApplicationSummary, repeated: true },
]);
//# sourceMappingURL=ems_service_pb.js.map